import { useState, useEffect, useRef } from "react";
import { noneProfile } from "assets";
import { Service } from "utils/services";
import { useNavigate } from "react-router-dom";
import { RouteUrl } from "utils";

export default function ImageUrlProfileStory({
  user,
  className,
  alt = "",
  isThumbnail = true,
  isLinkProfile = false,
}: {
  user: any;
  className?: string;
  alt?: string;
  isThumbnail?: boolean;

  isLinkProfile?: boolean;
}) {
  const [imageSrc, setImageSrc] = useState<string>(noneProfile);
  const cursorPointer = useRef<string>();
  const navigate = useNavigate();

  // * story
  const noOfStory = Service.toInteger(user.no_of_story);
  const noOfViewStory = Service.toInteger(user.no_of_view_story);

  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const segmentSize = circumference / noOfStory;
  const spaceBetweenSegments = 7;
  const adjustedSegmentSize = segmentSize - spaceBetweenSegments;

  useEffect(() => {
    if (!user || user === "") {
      setImageSrc(noneProfile);
    } else {
      let updatedSrc = isThumbnail ? user.thumbnail ?? "null" : user.picture ?? "null";

      if (Service.applicationMode.isDebug() && !updatedSrc && updatedSrc !== "") {
        updatedSrc = updatedSrc.replace("https", "http");
      }
      setImageSrc(updatedSrc);
    }
  }, [user, isThumbnail]); // Dependency array to update when `src` changes

  const handleError = () => {
    // Fallback to noneProfile if image fails to load

    setImageSrc(!user ? noneProfile : !user.avatar || user.avatar === "" || user.avatar === "null" ? noneProfile : `/${user.avatar}`);
  };

  if (isLinkProfile === true) {
    cursorPointer.current = "cursor-pointer";
  } else {
    cursorPointer.current = "";
  }

  const handleClick = () => {
    if (isLinkProfile === true) {
      navigate(`${RouteUrl.profile}?id=${user?.id}`);
    }
  };

  return (
    <div className="flex flex-col items-center space-y-2">
      <div className={`relative p-1 ${className}`}>
        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100">
          {Array.from({ length: noOfStory }).map((_, index) => {
            const isViewed = index < noOfViewStory;
            const offset = index * segmentSize; // Position each segment
            return (
              <circle
                key={index}
                cx="50"
                cy="50"
                r={radius}
                fill="none"
                stroke={isViewed ? "#a1a1aa" : "url(#gradient)"} // Gray if viewed, green if unviewed
                strokeWidth="4"
                strokeDasharray={`${adjustedSegmentSize} ${circumference - adjustedSegmentSize}`}
                strokeDashoffset={-offset} // Position segment correctly
                strokeLinecap="round"
              />
            );
          })}

          {/* Gradient Definition */}
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#4ade80" /> {/* Green */}
              <stop offset="100%" stopColor="#3b82f6" /> {/* Blue */}
            </linearGradient>
          </defs>
        </svg>

        {/* Profile Image */}
        <div className="w-full h-full rounded-full overflow-hidden border-2 ">
          <img
            className="w-full h-full object-cover rounded-full"
            src={imageSrc}
            alt={alt}
            onClick={handleClick}
            onError={handleError} // Fallback on error
          />
        </div>
      </div>
    </div>
  );
}

